export function fixedAndCommaNumbers(number) {
  return number.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  });
}
